import React from 'react';
import { Helmet } from 'react-helmet';
import qualityServiceImg from '../../images/dental.webp';
import teeth1 from '../../images/teeth1.webp';
import './QualityService.css';

const QualityService = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "MedicalBusiness",
    "name": "Digitale Zahnpraxis Dr. Alshoutaiui",
    "image": [qualityServiceImg, teeth1],
    "description": "Höchste Qualitätsstandards in der Zahnmedizin - Moderne Behandlungen für alle Altersgruppen in Salzburg",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Roseggerstraße 23",
      "addressLocality": "Salzburg",
      "postalCode": "5020",
      "addressCountry": "AT"
    },
    "medicalSpecialty": "Dentistry"
  };

  return (
    <div className="row lg:flex lg:px-8 sm:pb-8 md:pb-8 fadeIn">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      </Helmet>

      <div className="lg:basis-2/6 md:basis-1/4 p-16">
        <div className="flex justify-center items-center md:justify-center lg:justify-start">
          <div className="image-container max-w-sm">
            <img
              src={qualityServiceImg}
              className="hover:scale-110 transition-transform duration-300 ease-in-out"
              alt="Moderne Zahnbehandlungen in Salzburg - Dr. Alshoutaiui's Praxis mit neuester Technologie"
              loading="lazy"
              width="600"
              height="600"
            />
          </div>
        </div>
      </div>

      <div className="lg:basis-4/6 md:basis-3/4 col-8 lg:pt-16 px-16">
        <h1 className="text-3xl font-Poppins font-semibold">
          Zahngesundheit auf höchstem Niveau -
          <span className="text-primary"> für jedes Alter</span>
        </h1>
        <p className="py-8">
          Die Gründung der <strong>Digitalen Zahnpraxis Salzburg</strong> erfolgte als Antwort auf die
          steigende Nachfrage nach hochwertigen zahnärztlichen Dienstleistungen
          für die Bewohner von Salzburg. Unser Ziel war es, die höchsten
          Standards der Zahnpflege auf sanfte und professionelle Weise zu
          gewährleisten. Unser Team von Fachleuten ist bestrebt, sowohl
          Erwachsenen als auch Kindern eine maßgeschneiderte und optimale
          Zahnpflege zu bieten, indem wir nur die modernsten Technologien und
          Geräte verwenden. Dank unserer zentralen Lage im Herzen von Salzburg
          können Sie sich darauf verlassen, dass Sie von unserem
          hochqualifizierten Personal in einer einladenden und entspannten
          Umgebung betreut werden.
        </p>

        <div className="lg:flex justify-between">
          <ul>
            {[
              "WIR BIETEN EINE QUALITÄTSBEHANDLUNG",
              "BESTER PREIS",
              "Individuelle Beratung"
            ].map((item, index) => (
              <li 
                key={index}
                className="flex hover:scale-110 transition-transform duration-300 ease-in-out"
                itemProp="makesOffer"
                itemScope
                itemType="https://schema.org/Offer"
              >
                <i 
                  className="far fa-hand-point-right text-3xl text-green-500"
                  aria-hidden="true"
                ></i>
                <h2 className="text-lg pb-8 px-4 uppercase font-bold leading-snug text-black hover:opacity-75">
                  <span itemProp="name">{item}</span>
                </h2>
              </li>
            ))}
          </ul>

          <div>
            <img 
              src={teeth1} 
              alt="Verschiedene Zahnbehandlungsoptionen in Salzburg - Implantologie, Prophylaxe, Kinderzahnheilkunde"
              loading="lazy"
              width="400"
              height="300"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QualityService;